import { render, staticRenderFns } from "./VariableWidget.vue?vue&type=template&id=06b82543&"
import script from "./VariableWidget.vue?vue&type=script&lang=ts&"
export * from "./VariableWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports